import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { submitForm } from '../../services/formService';
import { pushGTMEvent } from '../../utils/analytics';
import Form from 'pubweb-smokey/dist/components/Form/Form';

const Forms = () => {

    const [isError, setIsError] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [ formData, setFormData ] = useState([]);
    const { register, handleSubmit, formState: { errors } } = useForm();

    const onSubmit = (data) => {
        setIsProcessing(true);
        setFormData(data);
        submitForm(data)
        .then( res => {
            pushGTMEvent('Consumer_Affairs', 'Form Button', 'Form Submission - View Homes');
            setIsProcessing(false);
            setIsSubmitted(true);
        })
        .catch(err => {
            console.log(`There was an error posting form request: ${err}`);
            setIsProcessing(false);
            setIsError(true);
        });
    }

    return (
        <div className="form-wrapper">
            {
                (isProcessing) ? 
                    <div className="disabled-overlay">
                        <div className="overlay-text">Submitting...</div>
                        <div className="overlay-spinner" />
                    </div>
                    : null
            }
            {
                (isError) ?
                    <div className="error-message">
                        {
                            setIsProcessing(false)
                        }
                        There was an error submitting your request. Please try again.
                    </div>
                    : null
            }
            {
                (!isSubmitted) ?
                    <div>
                        <p>Fill out the form to receive more information about Clayton Built&reg; homes and be contacted by a Clayton representative</p>
                        <Form className="LeadForm" onSubmit={handleSubmit(onSubmit)} noValidate>
                            <fieldset disabled={isProcessing}>
                                <div className="form-row">
                                    <div className="form-name">
                                        <input
                                            placeholder="First*"
                                            {...register("firstName", {pattern: { value: /^[a-zA-Z ,.'-]+$/, message: 'Please enter a valid first name'}, required: 'Please add your first name'})}
                                        />
                                        <div className={'form-invalid-feedback ' + ((errors.firstName)? 'is-invalid' : '')}>{errors.firstName?.message}</div>
                                    </div>
                                    <div className="form-name">
                                        <input
                                            placeholder="Last*"
                                            {...register("lastName", {pattern: { value: /^[a-zA-Z ,.'-]+$/, message: 'Please enter a valid last name'}, required: 'Please add your last name'})}
                                        />
                                        <div className={'form-invalid-feedback ' + ((errors.lastName)? 'is-invalid' : '')}>{errors.lastName?.message}</div>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-email">
                                        <input
                                            placeholder="Email*"
                                            {...register("email", {pattern: {value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                            message: 'Please enter a valid email address'}, required: 'Please add a valid email address'})}
                                        />
                                        <div className={'form-invalid-feedback ' + ((errors.email)? 'is-invalid' : '')}>{errors.email?.message}</div>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-zip">
                                        <input
                                            placeholder="Zip*"
                                            {...register("zip", {maxLength: 5, pattern: {value: /^(\d{5})?$/, message: 'Please enter a valid zip'}, required: 'Please add a valid zip'})}
                                        />
                                        <div className={'form-invalid-feedback ' + ((errors.zip)? 'is-invalid' : '')}>{errors.zip?.message}</div>
                                    </div>
                                    <div className="form-phone">
                                        <input
                                            placeholder="Phone*"
                                            {...register("phone", {pattern: {value: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, message: 'Please enter a valid phone number'}, required: 'Please add a valid phone number'})}
                                        />
                                        <div className={'form-invalid-feedback ' + ((errors.phone)? 'is-invalid' : '')}>{errors.phone?.message}</div>
                                    </div>
                                </div>
                                <p className="required-text">*All form fields are required!</p>
                                <div className="form-row">
                                    <button type="submit">
                                        View Homes
                                    </button>
                                </div>
                            </fieldset>
                        </Form>
                    </div> :   
                    <div className="thank-you">
                        <h4>
                            Thank you!<br />
                            Your information was submitted.<br />
                            <a className="submit-btn" href={`https://www.claytonhomes.com/find-a-home/city--st--${formData.zip}`}>
                                View Homes
                            </a>
                        </h4>
                    </div>
            }
        </div>
    );
};

export default Forms;